import React, { useState } from 'react';
import { View } from 'react-native-web';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';
import { Title } from 'app/src/styles';

import { CREATE_USER } from './queries';

export const FIELDS = {
  name: {
    label: 'Username',
    hint: 'Part of email address before the @',
    rules: {
      pattern: {
        value: /^[^\s@]+$/,
        message: 'Cannot include whitespace or @',
      },
      required: true,
    },
  },
  projectId: {
    label: 'Project',
    rules: { required: true },
  },
  displayName: {
    hint: 'Currently just used for reference',
    rules: { required: true },
  },
  password: {
    label: 'Initial password',
    rules: { required: true },
  },
};

const NewUser = ({ setShow, refetch, projects }) => {
  const [formStatus, setFormStatus] = useState();

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const [createUser] = useMutation(CREATE_USER, {
    onCompleted: () => {
      refetch();
      setShow(false);
    },
    onError: () => {
      setFormStatus(null);
    }
  });

  const onSubmit = input => {
    setFormStatus('submitting');

    createUser({
      variables: { ...prepareInput(input, FIELDS) }
    });
  };

  const fields = { ...FIELDS };

  fields.projectId = {
    ...fields.projectId,
    select: [{ value: '', label: 'Select' }, ...projects],
  };

  return (
    <Modal title="Create Email Account" setShow={setShow}>
      <Fields fields={fields} control={control} errors={errors} />

      <Button
        label="Create Email Account"
        onPress={handleSubmit(onSubmit)}
        disabled={'submitting' === formStatus}
        wide
      />
    </Modal>
  );
};

export default NewUser;
